import {
  SearchAssignedMalls,
  SearchAssignedMallsVariables
} from "@saleor/coupons/types/SearchAssignedMalls";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeMeTopLevelSearch from "@saleor/hooks/makeMeTopLevelSearch";
import gql from "graphql-tag";

export const searchAssignedMalls = gql`
  ${pageInfoFragment}
  query SearchAssignedMalls(
    $after: String
    $brandId: ID
    $first: Int!
    $query: String!
    $filterStatus: String
    $status: SmopStatusEnum
    $sortBy: MallSortingInput
  ) {
    me {
      search: malls(
        after: $after
        first: $first
        filter: { search: $query, brand: $brandId, status: $filterStatus }
        status: $status
        sortBy: $sortBy
      ) {
        edges {
          node {
            id
            name
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
      }
    }
  }
`;

export default makeMeTopLevelSearch<
  SearchAssignedMalls,
  SearchAssignedMallsVariables
>(searchAssignedMalls);
